module.exports = __webpack_public_path__ + "img/noResultTwo.1d50cb32.png";